import LogDNALogger from 'logdna';
import * as ErrorService from 'shared-services/error-service';

import { debugLogEnabled } from 'services/env-service';

let userProps = {};

const logDNALogger = LogDNALogger.createLogger('be85c4cb54d7c56a63f052428c80abe5', {
    hostname: 'client-device',
    app: 'niftypm.client',
    env: 'frontend',
    index_meta: true
});

export const logError = (type = 'general', error, extraData) => {
    console.error(error);

    if (type === 'saga') {
        return;
    }

    ErrorService.logError({
        type,
        error,
        customData: extraData
    });
}

export const debugLog = (...args) => {
    if (!debugLogEnabled()) {
        return;
    }

    console.log(...args);
}

export const remoteLog = (...args) => {
    debugLog(...args);
    logDNALogger.log(...args[0], {
        meta: {
            userId: userProps?.id,
            email: userProps?.email
        }
    });
}

export const setUserProps = props => {
    userProps = props;
    ErrorService.setUserProps(props);
};
